module.exports = __webpack_public_path__ + "static/img/5.aef608d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/5.png
// module id = xUic
// module chunks = 0